const fabric = window.fabric;

class Drawing {
  constructor() {
    this._el = null;
    this._list = {};
    this._curPage = 0;
    this._currentWidth = 5;
    this._currentColor = "#ff0000";
    this._currentAlpha = 1;
  }

  _hexToRGBA = (hex, alpha = "1") => {
    let c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split("");
      if (c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = "0x" + c.join("");

      const returnColor = `rgba(${[
        (c >> 16) & 255,
        (c >> 8) & 255,
        c & 255,
      ].join(",")},${alpha})`;

      return returnColor;
    }
    throw new Error("Bad Hex");
  };

  initCanvas = (wrapper, length) => {
    this._el = wrapper;
    this._curPage = `canvas-${1}`;
    let count = 1;
    let canvas = ``;
    for (let i = 0; i < length + 1; i++) {
      canvas += `<canvas class="draw-canvas" data-key=canvas-${count}></canvas>`;
      count += 2;
    }
    wrapper.innerHTML = canvas;

    document.querySelectorAll(`.draw-canvas[data-key]`).forEach((el) => {
      let canvas = new fabric.Canvas(el, {
        isDrawingMode: true,
        selection: false,
        width: 1664 * window.__scale,
        height: 830 * window.__scale,
      });

      const key = el.getAttribute("data-key");
      canvas.freeDrawingBrush.width = this._currentWidth;
      canvas.freeDrawingBrush.color = this._hexToRGBA(
        this._currentColor,
        this._currentAlpha
      );
      canvas.__eraser = new fabric.EraserBrush(canvas);
      canvas.__pencil = new fabric.PencilBrush(canvas);
      canvas.__key = key;

      this._list[key] = {
        canvas: canvas,
        el: canvas.wrapperEl,
      };
    });
  };

  getCanvas(page) {
    const c = this._list[`canvas-${page}`];
    if (c) return c.canvas;
    return null;
  }

  undo() {
    const c = this._list[this._curPage];
    if (c) {
      c.canvas.undo();
    }
  }

  redo() {
    const c = this._list[this._curPage];
    if (c) {
      c.canvas.redo();
    }
  }

  clear = () => {
    const c = this._list[this._curPage];
    if (c) {
      c.canvas.clear();
      c.canvas.clearHistory();
    }
  };

  changeType = (type) => {
    for (const s in this._list) {
      const { canvas } = this._list[s];
      if (type === "eraser") {
        canvas.freeDrawingBrush = canvas.__eraser;
        canvas.freeDrawingBrush.width = this._currentWidth;
      } else {
        if (type === "pencil") {
          this._currentAlpha = 1;
        } else {
          this._currentAlpha = 0.5;
        }
        canvas.freeDrawingBrush = canvas.__pencil;
        canvas.freeDrawingBrush.width = this._currentWidth;
        canvas.freeDrawingBrush.color = this._hexToRGBA(
          this._currentColor,
          this._currentAlpha
        );
      }
    }
  };

  changeLine = (type) => {
    const types = {
      small: 2,
      medium: 5,
      large: 15,
    };
    this._currentWidth = types[type];
    for (const s in this._list) {
      const { canvas } = this._list[s];
      canvas.freeDrawingBrush.width = types[type];
    }
  };

  setColor = (color) => {
    this._currentColor = color;
    for (const s in this._list) {
      const { canvas } = this._list[s];
      canvas.freeDrawingBrush.color = this._hexToRGBA(
        this._currentColor,
        this._currentAlpha
      );
    }
  };

  show = (page) => {
    this._curPage = `canvas-${page}`;
    this._el.classList.add("show");
    for (const p in this._list) {
      const { canvas, el } = this._list[p];
      canvas.isDrawingMode = true;
      if (p === `canvas-${page}`) {
        el.style.display = "block";
      } else {
        el.style.display = "none";
      }
    }
  };

  hide = () => {
    this._curPage = null;
    if (this._el) this._el.classList.remove("show");
    for (const s in this._list) {
      const { canvas } = this._list[s];
      canvas.isDrawingMode = false;
    }
  };

  destroy = () => {
    for (const s in this._list) {
      const { canvas } = this._list[s];
      canvas.dispose();
      this._list[s].canvas = null;
      this._list[s].el = null;
      delete this._list[s];
    }
    this._el = null;
    this._list = {};
    this._curPage = 0;
  };
}

export default new Drawing();
